<template>
  <receivables-analysis v-if="revenueBeta" />
  <receivables-legacy v-else />
</template>
<script>
import ReceivablesAnalysis from '@/views/payment/ReceivablesAnalysis'
import ReceivablesLegacy from '@/views/payment/ReceivablesLegacy'

import RevenueBetaMixin from '@/mixins/RevenueBetaMixin'

export default {
  components: {
    ReceivablesAnalysis,
    ReceivablesLegacy
  },
  mixins: [
    RevenueBetaMixin
  ]
}
</script>
